import React from 'react'
import * as TwoStepPaymentForm from '../../../../common/components/entities/TwoStepPaymentForm'
import useCashOnDeliveryPaymentHandler from '../../../hooks/payment/useCashOnDeliveryPaymentHandler'
import useManagement, {
  selectors as managementSelectors,
} from '../../../hooks/useManagement'
import FieldErrors from '../../FieldErrors'
import { TwoStepPaymentButtonProps } from './TwoStepPaymentButtonProps'

export default function TwoStepCashOnDeliveryPaymentButton({
  entity,
  styles,
  mobileStyles,
}: TwoStepPaymentButtonProps) {
  const { isLoading, handleSubmit, errors } =
    useCashOnDeliveryPaymentHandler(entity)

  const isPreview = useManagement(managementSelectors.isPreviewMode)

  return (
    <React.Fragment>
      <TwoStepPaymentForm.Button
        onClick={handleSubmit}
        styles={styles}
        mobileStyles={mobileStyles}
        text={entity.options.buttonText}
        subText={entity.options.buttonSubText}
        disabled={isLoading || isPreview}
      />
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}
